// This file is automatically generated by `generated_js` task. Any changes will be lost
/* tslint:disable */
export const GoCDVersion = {
  "version": "26.1.0",
  "buildNumber": "22803",
  "gitSha": "55b7b460510bb739c1ae6d226ff7fb650596dca2",
  "fullVersion": "26.1.0-22803",
  "formattedVersion": "26.1.0 (22803-55b7b460510bb739c1ae6d226ff7fb650596dca2)"
}


function stripLeadingPrefix(suffix: string, prefix: string) {
  if (suffix.startsWith(prefix)) {
      suffix = suffix.substring(1);
  }
  return suffix;
}

export function docsUrl(suffix: string = '') {
  return `https://docs.gocd.org/26.1.0/${stripLeadingPrefix(suffix, '/')}`
}

export function apiDocsUrl(suffix: string = '') {
  return `https://api.gocd.org/26.1.0/${stripLeadingPrefix(suffix, '#')}`
}
    
